import React from "react";
// import './SizeChart.module.css'
import styles from "./SizeChart.module.css"

const SizeChartTop = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.tittle}>Men's Top Wear</div>
        <div className={styles.sizeChart}>Size Charts</div>
        <div className={styles.headerBorder}></div>
        <div className={styles.size}>CM | INCHES</div>
        <table>
          <tr>
            <th>SIZE</th>
            <th>CHEST</th>
            <th>FRONT LENGTH</th>
            <th>ACROSS SHOULDER</th>
          </tr>
          <tr>
            <th>S</th>
            <th className={styles.tableDataStyle}>105 | 41.5</th>
            <th className={styles.tableDataStyle}>73.7 | 29.1</th>
            <th className={styles.tableDataStyle}>43.8 | 17.3</th>
          </tr>
          <tr>
            <th>M</th>
            <th className={styles.tableDataStyle}>110 | 43.5</th>
            <th className={styles.tableDataStyle}>74.9 | 29.5</th>
            <th className={styles.tableDataStyle}>45.7 | 18.1</th>
          </tr>
          <tr>
            <th>L</th>
            <th className={styles.tableDataStyle}>116 | 45.5</th>
            <th className={styles.tableDataStyle}>76.2 | 30.1</th>
            <th className={styles.tableDataStyle}>47.6 | 18.8</th>
          </tr>
          <tr>
            <th>XL</th>
            <th className={styles.tableDataStyle}>121 | 47.5</th>
            <th className={styles.tableDataStyle}>78.2 | 30.8</th>
            <th className={styles.tableDataStyle}>49.5 | 19.5</th>
          </tr>
          <tr>
            <th>2XL</th>
            <th className={styles.tableDataStyle}>126 | 49.5</th>
            <th className={styles.tableDataStyle}>78.7 | 31.1</th>
            <th className={styles.tableDataStyle}>51.4 | 20.3</th>
          </tr>
        </table>

        <img
          src="https://cdn.kiwisizing.com/shop-8e4b-aacdfe3d0878-1602843231913.png"
          alt="size-chart"
        />

        <div className={styles.sizeDescription}>
          <p>
            <span>Neck to Shoulder: </span>Measure from the middle of the neck
            to end of shoulder (where the sleeve starts).
          </p>
          <p>
            <span>Sleeve length (A): </span>Measure from the center back of
            collar to the end of shoulder.
          </p>
          <p>
            <span>Sleeve length (B): </span>Measure from the shoulder to the
            wrist.
          </p>
          <p>
            <span>Shoulder to Shoulder: </span>Measure this length from one
            shoulder to another.
          </p>
          <p>
            <span>Chest: </span>Measure around the fullest part, place the tape
            close under the arms and make sure the tape is flat across the back.
          </p>
          <p>
            <span>Front Length: </span>Measure from the highest point of the
            shoulder to the desired hemline.
          </p>
          <p>
            <span>Hem: </span>Measure from one side to another, but it is vital
            to take this measurement from above the elastic area (If sweatshirt
            have any).
          </p>
          <p>
            <span>Sleeve cuff: </span>At the widest point of the wrist, measure
            its circumference. Leave enough room for watches or jewelry worn
            often. Take this measurement from above the elastic area same as Hem
            length measurement
          </p>

          <p className={styles.sizeDescriptionCaption}>
            Sizes can vary from 2-3 centimeters because they are measured by
            hand. 1inch=2.54cm The size matched on a label can differ from the
            one you have ordered
          </p>
        </div>
      </div>
    </div>
  );
};

export default SizeChartTop;
